import { nameSegment, summarizeServiceConditions } from '~/components/AiSearchChips/ServicesChips/summarizeServicePredicate';
import { SERVICE_QUANTIFIERS } from '~/types/api/search-common';
export const collectionOperatorLabel = (quantifier, t)=>quantifier === 'none' ? t.operatorExclude() : undefined;
export const isExistenceCollectionPredicate = (predicate)=>{
    var _predicate_or;
    return predicate.services == null && ((_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : []).length === 0 && nameSegment(predicate.name) == null;
};
const summarizeNestedServices = (services, t)=>SERVICE_QUANTIFIERS.map((quantifier)=>services[quantifier]).filter((predicate)=>predicate != null).map((predicate)=>summarizeServiceConditions(predicate, t)).filter((summary)=>summary !== '').join(', ');
const summarizeNameOrArm = (arms, t)=>arms.map((arm)=>nameSegment(arm.name)).filter((segment)=>segment != null).join(" ".concat(t.orConnector(), " "));
export const summarizeCollectionPredicate = (predicate, t)=>{
    const segments = [];
    const name = nameSegment(predicate.name);
    if (name != null) segments.push(name);
    if (predicate.services != null) {
        const serviceSummary = summarizeNestedServices(predicate.services, t);
        if (serviceSummary !== '') segments.push(serviceSummary);
    }
    if (predicate.or != null && predicate.or.length > 0) {
        const orSummary = summarizeNameOrArm(predicate.or, t);
        if (orSummary !== '') segments.push(orSummary);
    }
    return segments.join(', ');
};
